module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0058.jpg?v=40000870";